export const CONVERSATION_ASSIST_ROUTES = {
  HOME: 'home',
  RECOMMENDATION_SOURCES: 'recommendation',
  DETAILED_REPORTS: 'reports',
  SETTINGS: 'settings',
  WELCOME: 'welcome',
  KNOWLEDGE_BASES: 'kb',
  BOTS: 'bots',
  RULES: 'rules',
  RECOMMENDATION_RULES: 'recommendationRules',
  KB_RULES: 'kbRules',
  BOTS_RULES: 'botRules',
  CREATE_KB_RULE: 'createKbRule',
  CREATE_BOT_RULE: 'createBotRule',
  BOT_RULE_DETAILS: 'botRuleDetails',
  KB_RULE_DETAILS: 'kbRuleDetails',
  EDIT_KB_RULE: 'editKbRule',
  EDIT_BOT_RULE: 'editBotRule',
};

export const CONVERSATION_ASSIST_MENUS = [
  {
    name: CONVERSATION_ASSIST_ROUTES.HOME,
    title: 'home',
  },
  {
    name: CONVERSATION_ASSIST_ROUTES.RECOMMENDATION_SOURCES,
    title: 'recommendation-sources',
    featureFlag: '$isRecommendationSourcesAvailable',
  },
  {
    name: CONVERSATION_ASSIST_ROUTES.RECOMMENDATION_RULES,
    title: 'recommendation-sources',
    featureFlag: '$isRecommendationSourcesReadOnly',
  },
  {
    name: CONVERSATION_ASSIST_ROUTES.DETAILED_REPORTS,
    title: 'detailed-reports',
    featureFlag: '$isDetailedReportsEnabled',
  },
  {
    name: CONVERSATION_ASSIST_ROUTES.SETTINGS,
    title: 'settings',
  },
];

export const RECOMMENDATION_SOURCES_TAB_ID = {
  kb: 'kb',
  bot: 'bot',
};

export const RECOMMENDATION_SOURCES_MENU = [
  {
    id: RECOMMENDATION_SOURCES_TAB_ID.kb,
    name: CONVERSATION_ASSIST_ROUTES.KNOWLEDGE_BASES,
    title: 'kb',
  },
  {
    id: RECOMMENDATION_SOURCES_TAB_ID.bot,
    name: CONVERSATION_ASSIST_ROUTES.BOTS,
    title: 'bots',
  },
];

export const RECOMMENDATION_RULES_MENU = [
  {
    id: RECOMMENDATION_SOURCES_TAB_ID.kb,
    name: CONVERSATION_ASSIST_ROUTES.KB_RULES,
    title: 'kb',
  },
  {
    id: RECOMMENDATION_SOURCES_TAB_ID.bot,
    name: CONVERSATION_ASSIST_ROUTES.BOTS_RULES,
    title: 'bots',
  },
];

export const WELCOME_SUGGESTIONS_LINKS = [
  {
    link: 'https://knowledge.liveperson.com/release-notes',
    label: 'first',
  },
  {
    link: 'https://developers.liveperson.com/conversation-assist-overview.html',
    label: 'second',
  },
  {
    link: 'https://developers.liveperson.com/tutorials-guides-using-conversation-assist-overview.html',
    label: 'third',
  },
  {
    link: 'https://developers.liveperson.com/conversation-assist-agent-experience.html',
    label: 'fourth',
  },
  {
    link: 'https://developers.liveperson.com/conversation-assist-best-practices.html',
    label: 'fifth',
  },
  {
    link: 'https://talkyard.livepersonai.com/latest/conversation-assist',
    label: 'sixth',
  },
];

export const WELCOME_MAIN_POINTERS = ['first', 'second', 'third'];

export const TIME_PERIODS = [7, 30, 90];
export const ITEMS_PER_PAGE = [10, 20, 30];

export const REPORTS_TIME_PERIODS = ['all', 'daily', 'weekly', 'monthly'];

export const DIRECTION = {
  UP: 'up',
  DOWN: 'down',
};

Object.freeze(DIRECTION);

export const KB_THRESHOLDS = ['fair-good', 'good', 'very-good'];
export const KB_THRESHOLDS_KEY_VAL = {
  fp: 'fair-good',
  g: 'good',
  vg: 'very-good',
};

export const KB_THRESHOLDS_VAL_TO_KEY = {
  'fair-good': 'fp',
  good: 'g',
  'very-good': 'vg',
};

export const baseCAWidgetPayload = {
  componentName: 'AWModuleWidget.ConversationAssist',
  deleted: false,
  description: '',
  enabled: true,
  mode: 'published',
  name: 'On-Demand Recommendations',
  path: 'p/lp-le-conversation-assist-recommendations/latest/AWModuleWidget.ConversationAssist.umd.js',
  span: '1',
  type: 'module',
  url: '',
};

export const SITE_SETTINGS_CONTEXT_TYPES = {
  ACCOUNT: 'ACCOUNT',
};

export const CONVERSATION_ASSIST_SETTINGS_ID = {
  INLINE_RECOMMENDATIONS: 'inline-recommendations',
  INLINE_RECOMMENDATIONS_FEEDBACK: 'inline-recommendations-feedback',
  PRIVATE_NOTIFICATIONS: 'private-notifications',
};

export const SITE_SETTINGS = {
  PRIVATE_NOTIFICATIONS: 'messaging.bot.mute.notification',
};

export const LLM_PROMPTS_ACTION_ID = {
  enrichment: 'enrichmentPrompt',
  fallback: 'fallbackPrompt',
  llmPrompt: 'llmPrompt',
  fallbackLlmPrompt: 'fallbackLlmPrompt',
};

export const BELONG_OPERATOR_OPTIONS = [
  {
    id: 'AND',
    translationKey: 'belong-operator-options.and',
  },
  {
    id: 'OR',
    translationKey: 'belong-operator-options.or',
  },
];

export const RULE_TYPE = {
  KNOWLEDGE_BASE: 'knowledgeBase',
  BOT: 'bot',
};

export const MIN_CONFIDENCE = 70;
export const MAX_CONFIDENCE = 100;
export const VISIBLE_POINTS = [MIN_CONFIDENCE, Math.floor((MIN_CONFIDENCE + MAX_CONFIDENCE) / 2), MAX_CONFIDENCE];

export const ADD_ON_SOURCES_TYPE = {
  KNOWLEDGE_BASES: 'knowledgeBases',
  BOTS: 'bots',
};

export const QUERY_CATEGORIES = [
  {
    id: 'request-help',
    translationKey: 'request-help',
  },
  {
    id: 'offer-info',
    translationKey: 'offer-info',
  },
  {
    id: 'chit-chat',
    translationKey: 'chit-chat',
  },
  {
    id: '#unknown',
    translationKey: 'unknown',
  },
];

export const OFFER_RECOMMS_ID = {
  INLINE_AND_WIDGET: 'inline_and_widget',
  INLINE: 'inline',
  WIDGET: 'widget',
};

export const OFFER_RECOMMENDATIONS_IN_RULE_ADDONS = [
  {
    id: OFFER_RECOMMS_ID.INLINE_AND_WIDGET,
    translationKey: 'conversation-and-odw',
  },
  {
    id: OFFER_RECOMMS_ID.INLINE,
    translationKey: 'conversation',
  },
  {
    id: OFFER_RECOMMS_ID.WIDGET,
    translationKey: 'odw',
  },
];

export const OFFER_RECOMMENDATIONS_IN_RULE_ADDONS_ID_MAP = new Map([
  [OFFER_RECOMMS_ID.INLINE_AND_WIDGET, { isEnabledForInline: true, isEnabledForWidget: true }],
  [OFFER_RECOMMS_ID.INLINE, { isEnabledForInline: true, isEnabledForWidget: false }],
  [OFFER_RECOMMS_ID.WIDGET, { isEnabledForInline: false, isEnabledForWidget: true }],
]);

export const OFFER_RECOMMENDATIONS_IN_RULE_ADDONS_KEY = 'OFFER_RECOMMS';
export const INITIAL_ENRICHMENT_UPDATE_KEY = 'INITIAL_ENRICHMENT_UPDATE_KEY';

export const LLM_TOOLTIP_LINK = 'https://developers.liveperson.com/conversation-assist-copilot-assist-offer-enriched-answer-recommendations.html';

export const RULE_PAGE_TOP_LEARN_MORE_LINK = 'https://developers.liveperson.com/conversation-assist-setup-before-you-begin.html#conversation-assist-rule-setup';

export const CA_SETTINGS_TOGGLE_CONFIG_TYPES = {
  PDC_REPLIES: 'pdcReplies',
};
